(() => {
  const updateTrustPanel = (variant) => {
    document.querySelectorAll('[data-maness-product-trust]').forEach((panel) => {
      const label = panel.querySelector('[data-maness-stock-label]');
      const dot = panel.querySelector('[data-maness-stock-dot]');
      const delivery = panel.querySelector('[data-maness-delivery]');
      const subline = panel.querySelector('[data-maness-delivery-subline]');

      if (!label || !dot) return;

      if (!variant) {
        label.textContent = 'Kies een optie';
        dot.classList.add('is-unavailable');
        delivery?.classList.add('is-hidden');
        subline?.classList.add('is-hidden');
        return;
      }

      const available = Boolean(variant.available);
      label.textContent = available ? 'Op voorraad' : 'Niet op voorraad';
      dot.classList.toggle('is-unavailable', !available);
      delivery?.classList.toggle('is-hidden', !available);
      subline?.classList.toggle('is-hidden', !available);
    });

    document.querySelectorAll('[data-maness-mobile-buybar]').forEach((bar) => {
      const button = bar.querySelector('[data-maness-mobile-atc]');
      const buttonLabel = bar.querySelector('[data-maness-mobile-atc-label]');
      const status = bar.querySelector('[data-maness-mobile-status]');

      if (!button || !buttonLabel || !status) return;

      if (!variant) {
        button.disabled = true;
        buttonLabel.textContent = 'Kies een optie';
        status.textContent = 'Selecteer eerst een variant';
        return;
      }

      const available = Boolean(variant.available);
      button.disabled = !available;
      buttonLabel.textContent = available ? 'In winkelmand' : 'Uitverkocht';
      status.textContent = available ? 'Op voorraad · vandaag verzonden' : 'Momenteel niet op voorraad';
    });
  };

  const initVariantTrust = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => updateTrustPanel(data?.variant));
  };

  const initMobileBuybar = () => {
    const bars = [...document.querySelectorAll('[data-maness-mobile-buybar]')];
    if (!bars.length) return;

    const updateVisibility = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        bars.forEach((bar) => bar.classList.remove('is-visible'));
        return;
      }

      const headerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 72;
      const footer = document.querySelector('footer, .maness-footer-v3');
      const footerIsEntering = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;

      bars.forEach((bar) => {
        const productInfo = bar.closest('product-info');
        const mainSubmit = productInfo?.querySelector('.product-form__submit');
        if (!mainSubmit) {
          bar.classList.remove('is-visible');
          return;
        }

        const submitRect = mainSubmit.getBoundingClientRect();
        const primaryCtaHasPassed = submitRect.bottom < headerHeight + 12;
        bar.classList.toggle('is-visible', primaryCtaHasPassed && !footerIsEntering);
      });
    };

    let ticking = false;
    const requestVisibilityUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        updateVisibility();
      });
    };

    document.addEventListener('click', (event) => {
      const mobileButton = event.target.closest('[data-maness-mobile-atc]');
      if (!mobileButton || mobileButton.disabled) return;

      const productInfo = mobileButton.closest('product-info');
      const mainSubmit = productInfo?.querySelector('.product-form__submit');
      if (!mainSubmit || mainSubmit.disabled) return;

      mainSubmit.click();
    });

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    requestVisibilityUpdate();
  };

  const init = () => {
    initVariantTrust();
    initMobileBuybar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


/* MANESS mobile announcement fade rotation */
(function(){
  function initManessAnnouncement(){
    if(window.innerWidth >= 750) return;
    document.querySelectorAll('.maness-mobile-rotating').forEach(function(wrapper){
      const items=[...wrapper.querySelectorAll('.maness-announcement__item')];
      if(items.length<2 || wrapper.dataset.manessFadeReady) return;
      wrapper.dataset.manessFadeReady='true';
      let active=0;
      items.forEach((item,i)=>{
        item.style.display=i===0?'flex':'none';
        item.style.opacity=i===0?'1':'0';
      });
      setInterval(function(){
        items[active].style.opacity='0';
        setTimeout(function(){
          items[active].style.display='none';
          active=(active+1)%items.length;
          items[active].style.display='flex';
          requestAnimationFrame(()=>items[active].style.opacity='1');
        },250);
      },3000);
    });
  }
  document.addEventListener('DOMContentLoaded',initManessAnnouncement);
  document.addEventListener('shopify:section:load',initManessAnnouncement);
})();
